import CommonDataTable from "../DataTable";

function CrudDataTable({
  withTableFeatures = true,
  searchPlaceholder = "Search...",
  searchable = true,
  sortable = true,
  paginated = true,
  toolbarAction,
  ...props
}) {
  const isSearchEnabled = withTableFeatures && searchable;
  const isSortEnabled = withTableFeatures && sortable;
  const isPaginationEnabled = withTableFeatures && paginated;

  return (
    <CommonDataTable
      {...props}
      searchable={isSearchEnabled}
      sortable={isSortEnabled}
      paginated={isPaginationEnabled}
      searchPlaceholder={isSearchEnabled ? searchPlaceholder : ""}
      toolbarAction={toolbarAction}
    />
  );
}

export default CrudDataTable;
